<template>
    <div>

        <Header/>



            <div class="store-grid">
                <div class="search-bar">

                    <input v-model="search.text"
                           type="text"
                           placeholder="جستجو"/>

                    <button >
                        <i class="fa fa-arrow-left"></i>
                    </button>
                    <div class="category-title">
                        <h5>
                            دسته‌بندی‌ها
                        </h5>
                    </div>
                    <div class="search-filter">

                        <div class="menu-item">
                            <div class="header" @click="toggleMenu">الکترونیک</div>
                            <div class="children-wrapper">
                                <ul class="children-menu" v-show="menuOpen" transition="slide-in-out" v-el:menu-content>
                                    <a v-for="item in menuItems" v-bind:key="item.id">{{ item.title }}</a>
                                </ul>
                            </div>
                        </div>
                        <div class="menu-item">
                            <div class="header" @click="toggleMenu">پوشاک</div>
                            <div class="children-wrapper">
                                <ul class="children-menu" v-show="menuOpen" transition="slide-in-out" v-el:menu-content>
                                    <a v-for="item in menuItems2" v-bind:key="item.id">{{ item.title }}</a>
                                </ul>
                            </div>
                        </div>

                    </div>

                </div>
                <div class="container">

                    <kt-row v-if="status && store.products" class="mt-5">
                        <kt-col xs="12" md="4" v-for="product in filteredResources" v-bind:key="product.id">
                            <kt-panel>
                                <kt-panel-header class="p-2">
                                    <img class="w-100" :src="product.image"  alt="">
                                </kt-panel-header>
                                <div class="product-grid">
                                    <div class="grid-pieces">
                                        <h2 style="font-size:1.5rem">{{ product.title }}</h2>
                                        <div v-if="product.discount_value || product.discount_percent" style="text-align: left;">
                                            <span   class="text-right mb-2 discount-amount">{{ product.amount }} ریال</span>
                                            <span v-if="product.discount_value" class="text-right mb-2">{{ product.amount - product.discount_value }} ریال</span>
                                            <span v-if="product.discount_percent" class="text-right mb-2">{{product.amount - product.amount * (product.discount_percent / 100) }} ریال</span>

                                        </div>
                                        <div v-else style="text-align: left;">
                                            <span  class="text-right mb-2">{{ product.amount }} ریال</span>
                                        </div>
                                        <span  class="mb-2">تعداد {{ product.quantity }} </span>

                                    </div>

                                    <div class="btn-grid">

                                        <kt-button style="font-size: 10px;margin:0px 20px 20px 20px" @click="$router.push('/@'+store_slug+'/'+ product.id)">
                                            {{ $t('product.btn.watch') }} {{ $t('product.btn.self') }}
                                        </kt-button>
                                        <kt-button size="md"
                                                   variant="success" style="font-size: 15px;margin:0px 0px 20px 20px" @click="addCart(product)">
                                            {{ $t('btn.add_basket') }}
                                        </kt-button>
                                    </div>

                                </div>
                            </kt-panel>
                        </kt-col>
                    </kt-row>
                </div>
            </div>


    </div>

</template>

<script>
import { mapGetters } from 'vuex'
import Header from './components/header'

export default {

transitions: {
    'slide-in-out':{

        css: false,

            enter: function(el, done) {
            TweenLite.to(el, 0.4, {
                marginTop: '0px',
                ease: Power1.easeInOut,
                onComplete: done
            });
        },

        leave: function(el, done) {
            TweenLite.to(el, 0.4, {
                marginTop: '-' + this.height + 'px',
                ease: Power1.easeInOut,
                onComplete: done
            });
        }
    }
},

    ready: function() {
        this.height = this.menuItems.length * 48;
    },
    components:{
        Header
    },

    computed: {
        filteredResources (){
            if(this.search.text){
                return this.store.products.data.filter((item)=>{
                    if(item.title.startsWith(this.search.text)){
                        return this
                    }else{
                        return item.name.startsWith(this.search.text)
                    }

                })
            }else{
                return this.store.products.data;
            }
        }
    ,
        ...mapGetters('product',['product']),
        ...mapGetters('store', [
            'store', 'status'
        ]),
        ...mapGetters('cart',['cart'])
    },
    data() {
        return {
            'store_slug': this.$route.params.store,
            'isDroppedCat': false,
            'isDroppedSort': false,
            search: { filter: null, text: "" },
            menuOpen: false,
            menuItems: [{
                title: 'اپل'
            }, {
                title: 'سامسونگ'
            }, {
                title: 'ال‌جی'
            }, {
                title: 'شیاومی'
            }],
            menuItems2: [{
                title: 'آدیداس'
            }, {
                title: 'نایکی'
            }, {
                title: 'کوتون'
            }, {
                title: 'ال‌سی‌وای‌کی‌کی'
            }],
            height: 0
        }
    },

    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('store/publicAccess', vm.store_slug)
        })
    },
    methods: {
        toggleMenu: function() {
            this.menuOpen = !this.menuOpen;
        },
        addCart(product){
            // console.log(product);
            if (!JSON.stringify(this.cart).includes(JSON.stringify(product))){
                this.$store.dispatch('cart/add',product)
                localStorage.setItem('allCart',JSON.stringify(this.cart))
            }


        },
        dropCategory() {
            this.isDroppedCat = !this.isDroppedCat
        },
        dropSort(){
            this.isDroppedSort = !this.isDroppedSort
        },

    }
}
</script>

<style scoped>

html {
    display: grid;
    height: 100%;
}

body {
    margin: auto;
    background: linear-gradient(#5e2973, #692424);
}


button:focus {
    outline: solid thin #ff1c99;
}
.store-grid{
    display: grid;
    grid-template-columns: 1fr 2.5fr;
}

.list-category {
    position: fixed;
    padding: 0px;
    z-index: 1;
    width: 111px;
    height: 30%;
    margin: -20px 8px;
    list-style-type: none;
    -webkit-transform-origin: top;
    transform-origin: top;
    transition: -webkit-transform .4s ease-in-out;
    -webkit-transition: -webkit-transform .4s ease-in-out;
    transition: transform .4s ease-in-out;
    transition: transform .4s ease-in-out, -webkit-transform .4s ease-in-out;
    overflow: auto;
    border: 0;
    border-radius: 5px;
}
.list-category li {
    display: grid;
    grid-template-columns: 150px 100px;
    padding: 10px;
    background: #ededed;
    border-bottom: solid thin #eeeeee3d;
    color: #1bbcab;
}
.list-sort {
    position: absolute;
    padding: 0px;
    z-index: 1;
    width: 86px;
    height: 30%;
    margin: -20px 135px;
    list-style-type: none;
    -webkit-transform-origin: top;
    transform-origin: top;
    transition: -webkit-transform .4s ease-in-out;
    -webkit-transition: -webkit-transform .4s ease-in-out;
    transition: transform .4s ease-in-out;
    transition: transform .4s ease-in-out, -webkit-transform .4s ease-in-out;
    overflow: auto;
    border: 0;
    border-radius: 5px;
}
.list-sort li {
    display: grid;
    grid-template-columns: 150px 100px;
    padding: 10px;
    background: #ededed;
    border-bottom: solid thin #eeeeee3d;
    color: #1bbcab;
}
.search-filter{
    height: 310px;
    overflow: auto;
    background-color:
            white;
    border-radius: 5px;
}

.slide-enter, .slide-leave-to {
    -webkit-transform: scaleY(0);
    transform: scaleY(0);
}
    .cart-image{
        width: 60%;
        border-radius: 10%;
    }
    .cart-des{
        margin: -12px 10px;
    }
    .cart-btn{
        width: 100%;
        height: 50px;
        color: #1ebeae;
        background-color: #223538;
        border: 0;
    }
    .search-bar{
        background-color: #fff;
        height: 80px;
        margin: 38px 10px;
        border-radius: 10px;
    }
    .category-title{
        padding: 10px;
        background-color:
                #1dc9b7;
        margin: 50px 0px 0px;
        color:
                white;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }
.search-bar >input {
    margin: 10px 10px;
    width: 69%;
    height: 40px;
    border-radius: 10px;
    border: 0;
    background-color: #d8d8d875;
    color: black;
    font-size: 20px;
    padding: 10px;
}
    .search-bar>button{
        width: 33px;
        height: 30px;
        border: 0;
        background: #1dc9b7;
        color: white;
        border-radius: 5px;
        padding: 7px;
    }
    .search-bar> h6{
        margin: -7px 24px
    }
    .search-btn{
        margin: 24px 8px;
        padding: 10px 30px;
        background-color: #ededed;
        border: 0;
        border-radius: 5px;
        color: #1dc9b7;
    }

.product-grid{
    display: grid;
    grid-template-rows: 1fr 1fr;

}
.grid-pieces{
    grid-template-columns: 1fr 3fr;
    padding: 10px 10px;
    display: grid;
}





.left_widgets {
    margin-bottom: 30px;
}
.sidebar_box_shadow {
    box-shadow: 0px 10px 10px 0px rgba(153, 153, 153, 0.1);
}
.l_w_title h3 {
    margin: 50px 0px 20px 0px;
    font-size: 14px;
    color: #2a2a2ab5;
    font-weight: 900;
    line-height: 40px;
    position: relative;
    background-color: #e7f2f4;
    padding: 2px 13px;
    text-transform: uppercase;
    border-radius: 10px;
}
.p_filter_widgets .widgets_inner:last-child {
    border-bottom: 0px;
}
.p_filter_widgets .widgets_inner {
    border-bottom: 1px solid #eeeeee;
}
.widgets_inner {
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 0px;
    padding-bottom: 15px;
    list-style: none;
    margin: 0;
    padding: 1px;
}
.p_filter_widgets .list:first-child {
    padding-top: 0;
    margin-top: 0;
    border-top: 0px solid transparent;
}
.p_filter_widgets .list {
    border-top: 1px solid #ddd;
    padding-top: 25px;
    margin-top: 25px;
    list-style: none;
}

.p_filter_widgets .list li {
    margin-bottom: 18px;
    -webkit-transition: 0.5s;
    transition: 0.5s;
}
.p_filter_widgets .list li a {
    font-size: 14px;
    font-weight: normal;
    color: #606060;
    position: relative;
}
.btn-grid{
    display: grid;
    grid-template-columns: 1fr 3fr;
}
.justify-content-between {
    -ms-flex-pack: justify!important;
    justify-content: space-between!important;
}
.d-flex {
    display: -ms-flexbox!important;
    display: flex!important;
}
    .discount-amount{
        text-decoration: line-through;
        font-size: 10px;
        padding: 10px;
        color: red;
    }
    .list{
        overflow: auto;
        height: 300px;
    }
.menu-item {
    background:
            #fff;
    margin: 2px 10px;
}
.header {
    font-size: 15px;
    padding: 10px;
    background-color: rgba(29, 201, 183, 0.07);
}
.header:hover{
    background-color: rgba(29, 201, 183, 0.49);
}
.children-wrapper {
    overflow: hidden;
}
.children-menu {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
}
.children-menu a {
    display: flex;
    padding: 0px 20px;
    align-items: center;
    height: 48px;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 32px;
    text-decoration: none;


}
@media (max-width: 500px) {
    .store-grid {
    grid-template-columns: 1fr;
    grid-template-rows: 350px auto;

    }
    .search-filter{
        height: 180px;
    }


}


</style>